export const SORT_TYPES = {
    "popular": {
        label: "Самые популярные",
    },
    "priceUp": {
        label: "По возростанию цены"
    },
    "priceDown": {
        label: "По убыванию цены"
    },
    "startDate": {
        label: "По дате размещения"
    },
    "endDate": {
        label: "По дате окончания"
    }
};

export const BUSINESS_TYPES = {
    "gun-shop": { label: "Оруженый магазин" },
    "auto-shop": { label: "Автосалон" },
    "barber-shop": { label: "Барбершоп" },
    "carwash": { label: "Автомойка" },
    "clothes-shop": { label: "Магазин одежды" },
    "tuning": { label: "Тюнинг салон" },
    "gas-station": { label: "АЗС" }, 
    "item-shop": { label: "Магазин 24/7" }, 
    "tattoo-shop": { label: "Тату салон" }, 
};

export const PROPERTY_TYPES = {
    "apartament": { label: "Квартиры" },
    "house": { label: "Дома" },
};

export const VEHICLE_SHOWROOMS = {
    "pdm": { label: "Premium Deluxe Motosport" }
};

export const ITEM_TYPES = {
    "Clothes": { label: "Одежда" },
	"Weapons": { label: "Оружие" },
	"MeleeWeapons": { label: "Холодное оружие" },
	"Ammo": { label: "Патроны" },
	"Alco": { label: "Алкоголь" },
	"Eat": { label: "Еда" },
	"Water": { label: "Вода" },
	"Modification": { label: "Модификации" },
	"Cases": { label: "Кейсы" },
	"Improvement": { label: "Баффы" },
    "None": { label: "Прочее" },
};

export const TIME_RANGE_OPTIONS = {
    "yesterday": { label: "За вчера" },
    "week": { label: "За неделю" },
    "month": { label: "За месяц" },
    "quarter": { label: "За квартал" },
    "year": { label: "За год" },
};

export const CLOTHES_TYPES = {
    Bracelets: { label: "Браслеты" },
	Watches: { label: "Часы" },
	Glasses: { label: "Очки" },
	Hat: { label: "Головной убор" },
	Top: { label: "Верхняя одежда" },
	Undershit: { label: "Майка" },
	Jewelry: { label: "Аксессуар" },
	Feet: { label: "Обувь" },
	Bag: { label: "Рюкзак" },
	Leg: { label: "Штаны" },
	Gloves: { label: "Перчатки" },
	Ears: { label: "Серьги" },
	Mask: { label: "Маски" },
};

export const GENDER_TYPES = {
    Male: { label: "Мужской" },
    Female: { label: "Женский" },
};